import { render, staticRenderFns } from "./vnsHexagonListSubtitle.vue?vue&type=template&id=2f25f51f&scoped=true&"
import script from "./vnsHexagonListSubtitle.vue?vue&type=script&lang=js&"
export * from "./vnsHexagonListSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./vnsHexagonListSubtitle.vue?vue&type=style&index=0&id=2f25f51f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f25f51f",
  null
  
)

export default component.exports